/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanActionTypeEnum =
  (typeof RoutePlanActionTypeEnum)[keyof typeof RoutePlanActionTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanActionTypeEnum = {
  AssignFieldTester: 0,
  CreateAssignmentRequest: 1,
  CreatePersonalTransport: 2,
  CreatePlaceholder: 3,
  ApplyDriverSwap: 4,
  CreatePlannedStopover: 5,
  CreateRideAlong: 6,
} as const;
